import React, { useEffect, useLayoutEffect, useRef } from "react";

const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, onScrollBottom, ...other } = props;
  const listRef = useRef(null);
  const scrollTopRef = useRef(0);
  const shouldRestoreRef = useRef(false);

  // Restore scroll AFTER new items are rendered (before browser paint)
  useLayoutEffect(() => {
    const list = listRef.current;
    if (list && shouldRestoreRef.current) {
      list.scrollTop = scrollTopRef.current;
      shouldRestoreRef.current = false;
    }
  });

  useEffect(() => {
    const node = listRef.current;
    if (!node) return;

    const handleScroll = (e) => {
      const el = e.currentTarget;
      // Always keep the latest scroll position saved
      scrollTopRef.current = el.scrollTop;

      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
      if (atBottom && typeof onScrollBottom === "function") {
        shouldRestoreRef.current = true;
        onScrollBottom();
      }
    };

    node.addEventListener("scroll", handleScroll);
    return () => node.removeEventListener("scroll", handleScroll);
  }, [onScrollBottom]);

  return (
    <ul
      {...other}
      ref={(node) => {
        listRef.current = node;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
      }}
      style={{
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {children}
    </ul>
  );
});

export default ListboxComponent;
